/* Extra Elettronica · interazioni del rebranding (tema Ride, copia non pubblicata).
   - "Il tuo telefono": scelta del modello, ricordata su questo dispositivo (e si puo' togliere)
   - scheda prodotto: "Taglia" diventa "Modello" e il modello scelto viene preselezionato
   - menu: la voce "Valuta il tuo usato" punta alla pagina di valutazione
   - header che cambia allo scorrimento, comparse e scontrino animato */
(function () {
  'use strict';
  var KEY = 'xb-myphone';
  /* L'elenco dei modelli arriva dal tema (snippets/extra-models.liquid), dentro <template id="xb-models-tpl"> nella barra negozio. */
  function tpl() { var t = document.getElementById('xb-models-tpl'); return t && t.content ? t.content : null; }
  function chipModel(el) {
    return el ? { id: el.getAttribute('data-xb-model'), label: el.textContent.trim(), brand: el.getAttribute('data-xb-brand') || 'apple', q: el.getAttribute('data-xb-q') || el.textContent.trim() } : null;
  }
  function allModels() { var t = tpl(); return t ? Array.prototype.map.call(t.querySelectorAll('[data-xb-model]'), chipModel) : []; }
  function find(id) {
    if (!id || typeof id !== 'string') return null;
    var sel = '[data-xb-model="' + id.replace(/[^a-z0-9-]/g, '') + '"]', t = tpl();
    return chipModel((t && t.querySelector(sel)) || document.querySelector(sel));
  }
  /* pagina con i soli prodotti che hanno una variante per il modello (templates/collection.xb-telefono.liquid) */
  function phoneUrl(m) { return '/collections/all?view=xb-telefono#' + m.id; }
  function mine() { try { return find(JSON.parse(localStorage.getItem(KEY) || 'null')); } catch (e) { return null; } }
  function setMine(id) { try { if (id) localStorage.setItem(KEY, JSON.stringify(id)); else localStorage.removeItem(KEY); } catch (e) { } paintMine(); }

  /* da "IPHONE 13/13PRO/14" a [iphone-13, iphone-13-pro, iphone-14] */
  function normToken(tok, brand) {
    var t = tok.trim().toUpperCase().replace(/IIPHONE/g, 'IPHONE').replace(/SAMSUNG/g, '').replace(/IPHONE/g, '').trim();
    t = t.replace(/(\d)(PRO|PLUS|MAX|MINI|ULTRA)/g, '$1 $2').replace(/\s+/g, ' ').trim();
    if (brand === 'samsung' || /^S2\d/.test(t)) {
      var s = t.match(/^S(\d\d)\s*(PLUS|ULTRA)?$/);
      return s ? ['galaxy-s' + s[1] + (s[2] === 'PLUS' ? '-plus' : s[2] === 'ULTRA' ? '-ultra' : '')] : [];
    }
    var mp = { 'X': ['iphone-x-xs'], 'XS': ['iphone-x-xs'], 'XS MAX': ['iphone-xs-max'], 'XR': ['iphone-xr'], '8': ['iphone-8-se'], 'SE': ['iphone-8-se'], '8 PLUS': ['iphone-8-plus'], '7': ['iphone-7'], '7 PLUS': ['iphone-7-plus'] };
    if (mp[t]) return mp[t];
    var m = t.match(/^(1[1-8])(?: (MINI|PLUS|PRO MAX|PRO))?$/);
    if (m) return ['iphone-' + m[1] + ({ 'MINI': '-mini', 'PLUS': '-plus', 'PRO MAX': '-pro-max', 'PRO': '-pro' }[m[2]] || '')];
    return [];
  }
  /* per tutto il resto (Galaxy A e Z, iPhone 17e e Air, altre marche) confronto con i nomi dell'elenco */
  var KEYMAP = null;
  function mkey(s) { return String(s).toUpperCase().replace(/I+PHONE/g, 'IPHONE').replace(/SAMSUNG|GALAXY/g, '').replace(/\+/g, 'PLUS').replace(/[^A-Z0-9]/g, ''); }
  function byName(tok, brand) {
    if (!KEYMAP) { KEYMAP = {}; allModels().forEach(function (x) { KEYMAP[mkey(x.label)] = x.id; }); }
    var id = KEYMAP[mkey(tok)] || (brand === 'apple' ? KEYMAP[mkey('IPHONE ' + tok)] : null);
    return id ? [id] : [];
  }
  function compat(value) {
    if (!value) return [];
    var v = String(value).toUpperCase().replace(/IIPHONE/g, 'IPHONE');
    var brand = (/SAMSUNG/.test(v) || /^\s*S2\d/.test(v)) ? 'samsung' : 'apple';
    v = v.replace(/IPHONE/g, '').replace(/SAMSUNG/g, '').replace('X-XS', 'X/XS');
    var out = [];
    v.split(/\/|\s-\s|,/).forEach(function (p) {
      p = p.trim(); if (!p) return;
      var ids = normToken(p, brand);
      out = out.concat(ids.length ? ids : byName(p, brand));
    });
    return out;
  }
  window.ExtraCompat = compat;

  /* ---------- "Il tuo telefono" ---------- */
  function paintMine() {
    var m = mine();
    document.querySelectorAll('[data-xb-myphone-label]').forEach(function (el) { el.textContent = m ? m.label : 'scegli'; });
    document.querySelectorAll('[data-xb-model]').forEach(function (el) {
      var on = !!m && el.getAttribute('data-xb-model') === m.id;
      el.classList.toggle('is-mine', on);
      if (on) el.setAttribute('title', 'Tocca di nuovo per togliere il filtro'); else el.removeAttribute('title');
    });
    document.querySelectorAll('[data-xb-mine-link]').forEach(function (el) { if (m) { el.href = phoneUrl(m); el.hidden = false; el.querySelector('span').textContent = m.label; } else el.hidden = true; });
    document.querySelectorAll('[data-xb-clear]').forEach(function (el) { el.hidden = !m; });
  }
  /* toglie il modello scelto senza sceglierne un altro: il sito torna libero da ogni filtro */
  function forget() {
    setMine(null);
    try { if (location.hash && find(decodeURIComponent(location.hash.slice(1)))) history.replaceState(null, '', location.pathname + location.search); } catch (e) { }
    document.querySelectorAll('.xb-search-note').forEach(function (n) { n.remove(); });
    phonePage(); applyModel();
  }
  function dialog() {
    var d = document.getElementById('xb-phone-dialog');
    if (d) return d;
    var t = tpl(); if (!t) return null;
    d = document.createElement('dialog'); d.id = 'xb-phone-dialog'; d.className = 'xb-dialog'; d.setAttribute('aria-labelledby', 'xb-phone-title');
    d.innerHTML = '<div class="xb-dialog__in"><div class="xb-dialog__head"><div><h2 id="xb-phone-title">Che telefono hai?</h2><p>Ti mostriamo gli accessori compatibili e nelle schede prodotto scegliamo già il tuo modello.</p></div><button type="button" class="xb-dialog__close" data-xb-close aria-label="Chiudi">×</button></div>' +
      '<div class="xb-dialog__body"></div>' +
      '<div class="xb-dialog__foot"><span>La scelta resta solo su questo dispositivo.</span><button type="button" class="xb-link" data-xb-forget style="background:none;border:0;padding:0;font:inherit;cursor:pointer">Togli il filtro</button></div></div>';
    d.querySelector('.xb-dialog__body').appendChild(document.importNode(t, true));
    document.body.appendChild(d);
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    return d;
  }
  function openDialog() {
    var d = dialog(); if (!d) return;
    paintMine(); var m = mine(); if (m) tab(d, 'd-' + m.brand);
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    var cur = d.querySelector('.xb-chip.is-mine'); if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
  }
  function tab(scope, id) {
    scope.querySelectorAll('[data-xb-tab]').forEach(function (t) { var on = t.getAttribute('data-xb-tab') === id; t.setAttribute('aria-selected', on); var p = document.getElementById(t.getAttribute('data-xb-tab')); if (p) p.hidden = !on; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-xb-open-phone]'); if (t) { e.preventDefault(); openDialog(); return; }
    var c = e.target.closest('[data-xb-close]'); if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    var tb = e.target.closest('[data-xb-tab]'); if (tb) { tab(tb.closest('.xb-dialog, .xb-models, .xb-phone-page') || document, tb.getAttribute('data-xb-tab')); return; }
    var f = e.target.closest('[data-xb-forget]'); if (f) { e.preventDefault(); forget(); var fd = f.closest('dialog'); if (fd && fd.open) fd.close(); return; }
    var m = e.target.closest('[data-xb-model]'); if (m) {
      /* un secondo tocco sul modello gia' scelto lo toglie (e non porta via dalla pagina) */
      if (m.classList.contains('is-mine')) { e.preventDefault(); forget(); var xd = m.closest('dialog'); if (xd && xd.open) xd.close(); return; }
      setMine(m.getAttribute('data-xb-model')); var md = m.closest('dialog'); if (md && md.open) md.close();
    }
  });

  /* ---------- menu: voce Valuta il tuo usato ---------- */
  function navValuta() {
    var bar = document.querySelector('[data-xb-valuta]');
    var url = bar ? bar.getAttribute('data-xb-valuta') : '';
    document.querySelectorAll('.header a, .menu-drawer a').forEach(function (a) {
      if (/valuta\s+il\s+tuo\s+usato/i.test(a.textContent)) {
        a.classList.add('xb-nav-valuta');
        if (url && /\/pages\/contact\/?$/.test(a.getAttribute('href') || '')) a.setAttribute('href', url);
      }
    });
  }

  /* ---------- scheda prodotto ---------- */
  function modelFieldsets() {
    return Array.prototype.filter.call(document.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input'), function (fs) {
      var lab = fs.querySelector('legend, label.form__label');
      return lab && /taglia|modello/i.test(lab.textContent);
    });
  }
  function relabel() {
    modelFieldsets().forEach(function (fs) {
      var lab = fs.querySelector('legend, label.form__label');
      if (lab && /taglia/i.test(lab.firstChild ? lab.firstChild.textContent : lab.textContent)) {
        lab.childNodes.forEach(function (n) { if (n.nodeType === 3 && /taglia/i.test(n.textContent)) n.textContent = n.textContent.replace(/taglia/i, 'Modello'); });
        if (/taglia/i.test(lab.textContent) && lab.children.length === 0) lab.textContent = lab.textContent.replace(/taglia/i, 'Modello');
      }
    });
  }
  var applied = false;
  function applyModel() {
    var m = mine();
    modelFieldsets().forEach(function (fs) {
      var old = fs.parentNode.querySelector('.xb-model-note'); if (old) old.remove();
      Array.prototype.forEach.call(fs.querySelectorAll('input[type=radio]'), function (i) { if (!m) i.classList.remove('xb-hl-model'); });
      if (!m) return;
      var inputs = fs.querySelectorAll('input[type=radio]'), sel = fs.querySelector('select'), match = null;
      Array.prototype.forEach.call(inputs, function (i) { i.classList.remove('xb-hl-model'); if (!match && compat(i.value).indexOf(m.id) >= 0) match = i; });
      if (sel) Array.prototype.forEach.call(sel.options, function (o) { if (!match && compat(o.value).indexOf(m.id) >= 0) match = o; });
      var note = document.createElement('p'); note.className = 'xb-model-note';
      if (match) {
        if (match.tagName === 'INPUT') { match.classList.add('xb-hl-model'); if (!match.checked && !applied) { match.click(); } }
        else if (sel && sel.value !== match.value && !applied) { sel.value = match.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        note.innerHTML = '<span>Scelto per il tuo <b></b>.</span> <button type="button" data-xb-open-phone>Cambia telefono</button> <button type="button" data-xb-forget>Togli il filtro</button>';
      } else {
        note.classList.add('is-miss');
        note.innerHTML = '<span>Questo prodotto non è disponibile per il tuo <b></b>.</span> <button type="button" data-xb-open-phone>Cambia telefono</button> <button type="button" data-xb-forget>Togli il filtro</button>';
      }
      note.querySelector('b').textContent = m.label;
      fs.parentNode.insertBefore(note, fs.nextSibling);
    });
    applied = true;
  }

  /* ---------- testi del catalogo: iPhone scritto bene, varianti leggibili ---------- */
  function niceModel(v) {
    return String(v).replace(/(\d)(PRO|PLUS|MAX|MINI|ULTRA)/gi, '$1 $2').replace(/I?IPHONE/gi, 'iPhone').replace(/\bSAMSUNG\b/gi, 'Galaxy').replace(/\bPRO\b/g, 'Pro').replace(/\bMAX\b/g, 'Max').replace(/\bPLUS\b/g, 'Plus')
      .replace(/\bMINI\b/g, 'mini').replace(/\bULTRA\b/g, 'Ultra').replace(/(\d)(Pro|Plus|Max|mini)/g, '$1 $2').replace(/\s*\/\s*/g, ' / ');
  }
  function niceWord(v) { return /^[A-ZÀ-Ù\s']+$/.test(v) ? v.charAt(0) + v.slice(1).toLowerCase() : v; }
  function tidy() {
    document.querySelectorAll('.card__heading a, .card__heading, .product__title h1, .cart-item__name, .xb-stack__meta b, .predictive-search__item-heading').forEach(function (el) {
      el.childNodes.forEach(function (n) { if (n.nodeType === 3 && /iphone/i.test(n.textContent)) n.textContent = n.textContent.replace(/\bi?iphone\b/gi, 'iPhone'); });
    });
    var models = modelFieldsets();
    document.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input').forEach(function (fs) {
      var model = models.indexOf(fs) >= 0;
      fs.querySelectorAll('input[type=radio] + label').forEach(function (l) {
        if (l.getAttribute('data-xb-nice')) return;
        l.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = model ? niceModel(n.textContent) : niceWord(n.textContent.trim()); });
        l.setAttribute('data-xb-nice', '1');
      });
    });
  }
  function clampDescription() {
    var d = document.querySelector('.collection-hero__description');
    if (!d || d.scrollHeight < 160 || d.hasAttribute('data-xb-clamp')) return;
    d.setAttribute('data-xb-clamp', '1'); d.classList.add('xb-clamp');
    var b = document.createElement('button'); b.type = 'button'; b.className = 'xb-more'; b.textContent = 'Leggi tutto';
    b.addEventListener('click', function () { var closed = d.classList.toggle('xb-clamp'); b.textContent = closed ? 'Leggi tutto' : 'Riduci'; });
    d.parentNode.insertBefore(b, d.nextSibling);
  }

  /* ---------- carrello: quanto manca alla spedizione gratuita ---------- */
  var FREE = 49.99;
  function shipBar() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var spots = [document.querySelector('cart-drawer .drawer__header'), document.querySelector('#main-cart-items .title-wrapper-with-link')];
      spots.forEach(function (spot) {
        if (!spot) return;
        var old = spot.parentNode.querySelector('.xb-ship'); if (old) old.remove();
        if (!c.item_count) return;
        var tot = c.total_price / 100, left = Math.max(0, FREE - tot), pct = Math.min(100, Math.round(tot / FREE * 100));
        var el = document.createElement('div'); el.className = 'xb-ship' + (left <= 0 ? ' is-done' : '');
        el.innerHTML = '<p></p><span class="xb-ship__bar"><i style="width:' + pct + '%"></i></span>';
        el.querySelector('p').innerHTML = left > 0 ? 'Ti mancano <b>' + left.toFixed(2).replace('.', ',') + ' €</b> per la spedizione gratuita' : '<b>Spedizione gratuita</b> attiva sul tuo ordine';
        spot.parentNode.insertBefore(el, spot.nextSibling);
      });
    }).catch(function () { });
  }

  /* ---------- pagina "Accessori per il tuo telefono" ---------- */
  function phonePage() {
    var page = document.querySelector('[data-xb-phone-page]'); if (!page) return;
    var fromHash = find(decodeURIComponent((location.hash || '').slice(1)));
    if (fromHash && (!mine() || mine().id !== fromHash.id)) setMine(fromHash.id);
    var m = fromHash || mine(), n = 0;
    page.querySelectorAll('[data-xb-opts]').forEach(function (li) {
      var ok = !!m && li.getAttribute('data-xb-opts').split('|').some(function (v) { return compat(v).indexOf(m.id) >= 0; });
      li.hidden = !ok; if (ok) n++;
    });
    page.querySelectorAll('[data-xb-phone-name]').forEach(function (el) { el.textContent = m ? m.label : 'telefono'; });
    var sub = page.querySelector('[data-xb-phone-count]');
    if (sub) sub.textContent = !m ? 'Scegli il tuo modello: ti mostriamo solo cover, pellicole e skin compatibili.'
      : n ? (n === 1 ? '1 prodotto ha' : n + ' prodotti hanno') + ' una variante per il tuo ' + m.label + '. Nella scheda il modello è già selezionato.' : '';
    var empty = page.querySelector('[data-xb-phone-empty]'); if (empty) empty.hidden = !m || n > 0;
    var pick = page.querySelector('[data-xb-phone-pick]'); if (pick) pick.hidden = !!m;
    var call = page.querySelector('[data-xb-phone-call]'), bar = document.querySelector('[data-xb-phone]');
    if (call && bar) { call.href = 'tel:' + bar.getAttribute('data-xb-phone'); call.hidden = false; }
    if (m) document.title = 'Accessori per ' + m.label + ' – ' + document.title.split(' – ').pop();
  }

  /* ---------- ricerca: rimando alla pagina del proprio telefono ---------- */
  function searchNote() {
    var m = mine(); if (!m || location.pathname.indexOf('/search') !== 0) return;
    var h = document.querySelector('.template-search__header h1, #MainContent h1');
    if (!h || document.querySelector('.xb-search-note')) return;
    var n = document.createElement('p'); n.className = 'xb-model-note xb-search-note';
    n.innerHTML = '<span>Hai scelto <b></b>.</span> <a href="' + phoneUrl(m) + '" style="font-weight:700;color:inherit">Vedi solo gli accessori compatibili →</a> <button type="button" data-xb-forget>Togli il filtro</button>';
    n.querySelector('b').textContent = m.label;
    h.parentNode.insertBefore(n, h.nextSibling);
  }

  /* ---------- header, comparse, scontrino ---------- */
  function onScroll() { document.documentElement.classList.toggle('xb-scrolled', window.scrollY > 8); }
  function reveal() {
    var els = document.querySelectorAll('[data-xb-reveal], [data-xb-print]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in', 'is-printed'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); if (en.target.hasAttribute('data-xb-print')) en.target.classList.add('is-printed'); io.unobserve(en.target); } });
    }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    navValuta(); paintMine(); relabel(); tidy(); clampDescription(); reveal(); onScroll();
    shipBar(); searchNote(); phonePage();
    window.addEventListener('hashchange', phonePage);
    if (typeof window.subscribe === 'function') { try { window.subscribe('cart-update', function () { setTimeout(shipBar, 300); }); } catch (e) { } }
    document.addEventListener('click', function (e) { if (e.target.closest('.cart-remove-button, cart-remove-button, .quantity__button')) setTimeout(shipBar, 900); });
    if (modelFieldsets().length) setTimeout(applyModel, 150);
    window.addEventListener('scroll', onScroll, { passive: true });
    var main = document.getElementById('MainContent');
    if (main && 'MutationObserver' in window) {
      var busy = false;
      new MutationObserver(function () {
        if (busy) return; busy = true;
        requestAnimationFrame(function () { relabel(); tidy(); if (modelFieldsets().length && !document.querySelector('.xb-model-note') && mine()) applyModel(); busy = false; });
      }).observe(main, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();